import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import NavigationBar from "../../../../../utils/wizard/navigation";
import { DatePicker } from "../../../../../utils/form";
import moment from "moment";
import _ from "lodash";

const defaultValues = {
  date: moment().format("YYYY-MM-DD"),
};

const DateForm = ({ onFinish, DateFields = DatePicker, formMapper = _.identity, ...props }) => {
  const form = useForm({ defaultValues: _.assign({}, defaultValues, props.defaultValues) });
  const { handleSubmit } = form;

  return (
    <form onSubmit={handleSubmit(form => onFinish(formMapper(form)))} autoComplete="off">
      <Typography
        variant="title"
        sx={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          mb: 2,
        }}
      >
        Fecha
      </Typography>
      <DateFields
        form={form}
        name="date"
        label="Fecha"
        required
        {...props}
      />
      <NavigationBar step={4} {...props} />
    </form>
  );
};

export default DateForm;
